import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import HeaderIcon from '../headerIcon/HeaderIcon';
import redLogo from '../../environments/images/butlins/red_logo.png';
import whiteLogo from '../../environments/images/butlins/white_logo.png';
import './Header.scss';

const Header = ({
  backgroundType = 'transparent',
  showProfile = false,
  icon = '',
  showLogo = false,
  userName = '',
  type = '',
  date = '',
  members = '',
  referenceValue = '',
  minimalHeader = false,
}) => (
  <>
    {minimalHeader ? (<div className="minimal-header" />)
      : (
        <div className={classnames('header', backgroundType)}>
          <div className={classnames('header-main-container', showProfile ? 'with-profile' : 'without-profile')}>
            <div className="left-column">
              {!!icon && <HeaderIcon icon={icon} backgroundType={backgroundType} />}
            </div>
            <div className="center-column">
              {!!showLogo && (
              <img
                src={backgroundType === 'transparent' ? redLogo : whiteLogo}
                alt="Logo"
              />
              )}
            </div>
            <div className="right-column" />
          </div>
          {!!showProfile && (
          <div className="header-sub-container">
            <div className="profile">
              <div className="booking-data">
                <span className="name">{userName}</span>
                <span className="type">{type}</span>
                <span className="date">{moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY')}</span>
                <span className="members">{members}</span>
              </div>
              <div className="booking-reference">
                <span className="reference-label">Booking reference:</span>
                <span className="reference-value">{referenceValue}</span>
              </div>
            </div>
          </div>
          )}
        </div>
      )}
  </>
);

Header.propTypes = {
  backgroundType: PropTypes.oneOf(['transparent', 'red']),
  showProfile: PropTypes.bool,
  icon: PropTypes.string,
  showLogo: PropTypes.bool,
  userName: PropTypes.string,
  type: PropTypes.string,
  date: PropTypes.string,
  members: PropTypes.string,
  referenceValue: PropTypes.string,
  minimalHeader: PropTypes.bool,
};

export default Header;
